<template>
	<div class="wrapper-404">
		<c-empty text="抱歉，页面加载失败！" />
		<el-button plain @click="backHome">返回首页</el-button>
	</div>
</template>

<script setup>
import { useRouter } from '@/utils/api';

const router = useRouter();
const backHome = () => {
	router.replace({
		name: 'home'
	});
};
</script>

<style lang="less" scoped>
.wrapper-404 {
	padding: 64px 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
</style>
